const handleImageSelect = (event, setImage) => {
  const file = event.target.files[0];

  if (file) {
    if (file.size <= 1048576) {
      setImage(file);
    } else {
      alert("File size must be less than or equal to 1 MB.");
      event.target.value = ""; // Reset file input
    }
  }
};

export default handleImageSelect;
